import { CSSResult, css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const gridMenuStyle = {
  backgroundColor: css`var(--csc-grid-menu-background-color, ${csColorBackground.primary})`,
  columnGap: css`var(--csc-grid-menu-column-gap, ${csSpacing.spacing08})`,
  rowGap: css`var(--csc-grid-menu-row-gap, ${csSpacing.spacing08})`,
  maxHeight: css`var(--csc-grid-menu-max-height, 600px)`,
  masonryPaddingBottom: css`var(--csc-grid-menu-masonry-padding-bottom, ${csSpacing.spacing08})`,
  masonryPaddingInline: css`var(--csc-grid-menu-masonry-padding-inlein, ${csSpacing.spacing08})`,
  gridPaddingInline: css`var(--csc-grid-menu-grid-padding-inline, ${csSpacing.spacing08})`,
  sidebarMinWidth: css`var(--csc-grid-menu-sidebar-min-width, var(--csc-grid-menu-sidebar-width, auto))`,
  sidebarMaxWidth: css`var(--csc-grid-menu-sidebar-max-width, var(--csc-grid-menu-sidebar-width, auto))`,
  categoryLinkMargin: css`var(--csc-grid-menu-category-link-margin, ${csSpacing.spacing08})`
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  .wrapper {
    position: relative;
    max-height: ${gridMenuStyle.maxHeight};
    max-width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: ${gridMenuStyle.backgroundColor};
  }

  .grid-menu {
    flex-grow: 1;
    overflow-y: auto;
    position: relative;
    padding-top: ${csSpacing.spacing08};
    padding-bottom: ${csSpacing.spacing08};
    padding-right: 0;

    -webkit-mask-image: linear-gradient(to bottom, black 0%, black calc(100% - ${csSpacing.spacing09}), transparent 100%);
    mask-image: linear-gradient(to bottom, black 0%, black calc(100% - ${csSpacing.spacing09}), transparent 100%);
    -webkit-mask-mode: alpha;
    mask-mode: alpha;
    transition: -webkit-mask-image 0.3s ease-in-out, mask-image 0.3s ease-in-out;
  }

  .grid-menu:not(.show-gradient) {
    -webkit-mask-image: none;
    mask-image: none;
  }

  .grid-items-container {
    margin: 0 auto;
  }

  @media (min-width: 576px) {
    .grid-items-container {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .grid-items-container {
      max-width: 720px;
    }
  }

  @media (min-width: 992px) {
    .grid-items-container {
      max-width: 960px;
    }
  }

  @media (min-width: 1200px) {
    .grid-items-container {
      max-width: 1140px;
    }
  }

  @media (min-width: 1400px) {
    .grid-items-container {
      max-width: 1320px;
    }
  }

  .grid-items-container.grid-layout {
    display: grid;
    grid-template-columns: repeat(var(--csc-grid-menu-column-count, 4), 1fr);
    column-gap: ${gridMenuStyle.columnGap};
    row-gap: ${gridMenuStyle.rowGap};
    padding-inline: ${gridMenuStyle.gridPaddingInline};
  }

  .grid-items-container.masonry-layout {
    column-count: var(--csc-grid-menu-column-count);
    padding-inline: ${gridMenuStyle.masonryPaddingInline};
  }

  .grid-items-container.masonry-layout > * {
    page-break-inside: avoid;
    -webkit-column-break-inside: avoid;
    -moz-column-break-inside: avoid;
    break-inside: avoid;
  }

  .grid-items-container.masonry-layout > *:not(:last-child) {
    padding-bottom: ${gridMenuStyle.masonryPaddingBottom};
  }

  .more-indicator {
    position: absolute;
    z-index: 10;
    bottom: ${csSpacing.spacing06};
    left: 50%;
    transform: translateX(-50%);
  }

  .more-indicator[hidden] {
    display: none;
  }

  .container {
    max-height: ${gridMenuStyle.maxHeight};
    height: ${gridMenuStyle.maxHeight};
    display: flex;
    gap: ${csSpacing.spacing08};
    background-color: ${gridMenuStyle.backgroundColor};
  }

  .container .wrapper {
    width: 100%;
    max-height: 100%;
  }

  .sidebar {
    --cse-paper-padding-y: 0;
    --cse-paper-padding-x: 0;
    --cse-paper-height: 100%;

    min-width: ${gridMenuStyle.sidebarMinWidth};
    max-width: ${gridMenuStyle.sidebarMaxWidth};
  }

  .all-category-link-wrapper {
    display: flex;
    width: 100%;
    padding-left: ${csSpacing.spacing08};
    padding-right: ${csSpacing.spacing08};
  }

  .all-category-link-wrapper.top-left,
  .all-category-link-wrapper.top-right {
      margin-bottom: ${gridMenuStyle.categoryLinkMargin};
  }

  .all-category-link-wrapper.bottom-left,
  .all-category-link-wrapper.bottom-right {
      margin-top: ${gridMenuStyle.categoryLinkMargin};
  }

  .all-category-link-wrapper.top-left,
  .all-category-link-wrapper.bottom-left {
    justify-content: flex-start;
  }

  .all-category-link-wrapper.top-right,
  .all-category-link-wrapper.bottom-right {
    justify-content: flex-end;
    margin-top: ${gridMenuStyle.categoryLinkMargin};
  }
`
